const strUserProgramRoles = (user) => {
    let pRoles = []
    if (user?.roles) {
        for (var i in user.roles) {
            pRoles.push(user.roles[i].name)
        }
    }
    if (user.isAdmin) pRoles.push("Admin")
    return pRoles.join(", ") || 'NA'
}

export const BULK_STATUS_CHANGE_COLUMNS = [
    {
        Header: "First Name",
        accessor: "first_name",
    },
    {
        Header: "Last Name",
        accessor: "last_name",
    },
    {
        Header: "Email",
        accessor: "email",
    },
    {
        Header: "Status",
        accessor: "user_status_id",
    },
    {
        Header: "Level",
        accessor: "level"
    },
    {
        Header: "Program Roles",
        accessor: "role_id",
        Cell: ({ row, value }) => { return strUserProgramRoles(row.original) },
    }
]